module.exports = "https://portperrypedals.ca/_res/img/pp.c223c2d.jpg";